module.exports = __webpack_public_path__ + "static/media/credit_personal.66279e39.jpg";